import Icon from './icon';
export default {
  Icon,
  title: 'Grid',
  hotkey: 'g'
};